import React from "react";
import OrdersPage from "Common/Components/OrdersPage";

// سفارش‌های بارگیری شده = سفارش‌هایی که order_status آن‌ها loaded است.
// تحویل هر قلم در صفحه‌ی «کالاهای بارگیری‌شده» ثبت می‌شود.
const Index = () => (
  <OrdersPage
    pageTitle="سفارش‌های بارگیری شده"
    orderStatus="loaded"
    canRevert
    revertRoles={[]}
    emptyText="هیچ سفارشی بارگیری‌شده نیست"
  />
);

export default Index;
